import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import { convertDateToDdMmYyyy } from '@/function/function.js';

import EnteteBonEtFacture from '@/views/en-tete-bon-facture';
import EnteteA5 from '@/views/entete-a5';
import ExamenPreviewResult from '@/views/consultations/en-cours/examen-para/examen-preview-result'

import $ from 'jquery';

export default {
	name: 'examen-para-historique',
	components: {
        EnteteBonEtFacture, EnteteA5,
        ExamenPreviewResult
    },
	props: ["consultation_id", "is_printable"],
	data() {
		return {
			vm_state: open_menu_state,
			is_loading: true,
			is_empty: false,

            format_pdf: 'a5', //  A5 (si prescriptions <= 6 ) ou A4 ( si prescription > 6)
            width_pdf: '559px',
            font_size: 'font-14',
            date_resultat: '', //  Date d'enregistrement du résultat
            filename: '',

            result_preview: []
		}
	},
	computed: {
		examen_para_historique() {
			return this.$store.getters["examen_para_historique"]
		},

		consultationEnCours() {
            return this.$store.getters['consultationPatientEnCours']
        },

		consultation(){
            return this.$store.getters["consultationPatientEnCours"];
        },

		patient() {
            return this.$store.getters['patient'];
        },

		/**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

		/**
         * Calculer le prix total des analyses
         */
        total_prix_examen() {
            let total = 0;
            if (this.demande_examen_para) {
                if (this.demande_examen_para.length > 0) {
                    this.demande_examen_para.forEach(data => {
                        let prix = 0
                        prix = parseInt(data.type_examen_prix)
                        total += prix;
                    })
                }
            }
            return total;
        },
	},
    mounted() {
        
        

		let t = this;

        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (t.vm_state != 0) {
                    t.openMenu(t.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });

        this.date_resultat = convertDateToDdMmYyyy.convertDate(new Date());
        let tm = new Date()
        this.filename = 'Bulletin Examen_'+this.patient.nom+' '+this.patient.prenoms+'_'+tm.getTime()

        this.refreshExamenPara()
	},
	methods: {
        refreshExamenPara() {
			this.is_loading = true
			this.is_empty = true
			this.$store.dispatch('getDemandeExamen', { consultation_id: this.consultation_id, enCours: false }).then(() => {
				this.is_loading = false
				if (this.examen_para_historique.examens.length == 0) {
					this.is_empty = true
				} else {
					this.is_empty = false
				}
			})
		},

        previewResultExamen(demande_examen) {
            this.result_preview = demande_examen
        },

		/**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

		formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        setPdfFormat() {

            if (this.examen_para_historique.examens.length <= 6) {
                this.format_pdf = 'a5'
                this.width_pdf = '559px'
                this.font_size = 'font-14'
            } else if (this.examen_para_historique.examens.length <= 8) {
                this.format_pdf = 'a5'
                this.width_pdf = '559px'
                this.font_size = 'font-10'
            } else {
                this.format_pdf = 'a4'
                this.width_pdf = '800px'
                this.font_size = 'font-16'
            }

        },

        /**
         * Imprimer une demande d'analyse
         */
        async printBulletinExamen() {
            await this.setPdfFormat()

            this.$refs.exm_html2Pdf.generatePdf()
        },

        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                // const totalPages = pdf.internal.getNumberOfPages()

                let foot_content = 'Généré(e) via l\'application Clinicaa';
                // let foot_content = 'Tél : (+229) 65 05 25 65 / (+229) 99 13 85 85 || BP : 1299 Lomé';

                let la_medecin = 'Le Médecin';
                let lome_le = this.ville_le + this.date_resultat;
                // let total_a_payer = 'Total à payer: ' + this.total_prix_examen;
                // let total_label = 'Total à payer';

                if (this.format_pdf == 'a5') {
                    // A PAYER
                    pdf.setTextColor(0)
                    pdf.setFontSize(14)
                    // pdf.text(total_a_payer, (3.6), (pdf.internal.pageSize.getHeight() - 1.5))

                    // LOME LE
                    pdf.setTextColor(150)
                    pdf.setFontSize(8)
                    pdf.text(lome_le, (0.5), (pdf.internal.pageSize.getHeight() - 1))

                    // LA CAISSE
                    pdf.setTextColor(150)
                    pdf.setFontSize(8)
                    pdf.text(la_medecin, (4.7), (pdf.internal.pageSize.getHeight() - 1))

                    // FOOTER
                    pdf.setTextColor(150)
                    pdf.setFontSize(6)
                    pdf.text(foot_content, (2.3), (pdf.internal.pageSize.getHeight() - 0.1))
                } else {
                    // LOME LE
                    pdf.setTextColor(150)
                    pdf.setFontSize(10)
                    pdf.text(lome_le, (0.5), (pdf.internal.pageSize.getHeight() - 1.4))

                    // LA CAISSE
                    pdf.setTextColor(150)
                    pdf.setFontSize(10)
                    pdf.text(la_medecin, (7), (pdf.internal.pageSize.getHeight() - 1.4))

                    // FOOTER
                    pdf.setTextColor(150)
                    pdf.setFontSize(6)
                    pdf.text(foot_content, (3.333858), (pdf.internal.pageSize.getHeight() - 0.3))
                }

            }).save()
        },

        onProgress(ev) {
            console.log(ev)
        },

        hasStartedGeneration() {

        },

        hasGenerated(ev) {
            console.log(ev)
        }
	}
}


